const pageScrollToTop = (selectorName) => {
    const scrollableElement = document.querySelector(selectorName);
    if (scrollableElement)
        scrollableElement.scrollTop = 0;
};
export default pageScrollToTop;
